export var LayerStyle;
(function (LayerStyle) {
    LayerStyle["LayerText"] = "hotspot-text";
    LayerStyle["LayerTextTestMe"] = "hotspot-text-testme";
})(LayerStyle || (LayerStyle = {}));
